import { RootState } from "../store";

export const selectMetaDataState = (state: RootState) => state.metadata;
